import { PageHeader } from '../../layouts/Shells';
import { Button, EmptyState, Skeleton } from '../../components/ui';
import { SupplierReviewPortal } from '../supplierReviews/SupplierReviewPortal';
import { PortalNotifications } from '../supplierExchange/PortalNotifications';
import { useOwnSupplierOrganization } from './hooks';
import { useEffectiveSupplierOrg } from './MimicMode';

/**
 * The supplier portal shell. Organization gating first: RLS can return at
 * most the signed-in supplier's own (active) organization row, and an
 * inactive organization ends the portal here. With access confirmed, the
 * real portal (Phase 6 Stage 4) renders the review workspace.
 */
export function SupplierPortalPage() {
  // The organization is carried, not inferred: a mimicking super admin has
  // none on their own profile, and RLS no longer narrows to one row for them.
  const organizationId = useEffectiveSupplierOrg();
  const organization = useOwnSupplierOrganization(organizationId);

  function body() {
    if (organization.isPending) {
      return <Skeleton lines={3} label="Loading your organization" />;
    }
    if (organization.isError) {
      return (
        <EmptyState
          title="Your organization could not be loaded"
          description="Something went wrong. Try again in a moment."
          action={<Button onClick={() => void organization.refetch()}>Retry</Button>}
        />
      );
    }
    if (!organization.data) {
      // The profile or the organization is inactive: no organization data is
      // available and nothing else in the portal is either.
      return (
        <EmptyState
          title="Supplier access is not available"
          description="Your organization's access is currently inactive. Contact your TAP representative."
        />
      );
    }
    return (
      <>
        {/* The factory's half of the notification matrix, above the tabs so
            news is never behind a click. Renders nothing when there is none. */}
        <PortalNotifications />
        <SupplierReviewPortal />
      </>
    );
  }

  return (
    <>
      <PageHeader title="Supplier Portal" description="Your shared workspace with TAP." />
      {body()}
    </>
  );
}
